import { useState } from "react";
import { Hotel } from "lucide-react";
import HotelProviderSearch from "./travel/HotelProviderSearch";

/* "Hotels near {airport}" — airport-page hotel section with traveler filters.
   Deep-link mode: filter chips refine the search phrase sent to booking partners
   (campaign TP-AIRPORT-HOTELS for revenue attribution). */

const FILTERS = [
  ["shuttle", "Free airport shuttle"], ["shuttle24", "24-hour shuttle"],
  ["parkfly", "Park & fly"], ["breakfast", "Breakfast included"], ["late", "Late check-in"],
];
const PHRASE = {
  shuttle: "free airport shuttle", shuttle24: "24 hour shuttle",
  parkfly: "park and fly parking", breakfast: "breakfast included", late: "late check-in",
};

export default function AirportHotels({ airportName, iata }) {
  const [active, setActive] = useState([]);
  const toggle = (id) => setActive((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));

  const base = `hotels near ${airportName}${iata ? ` (${iata})` : ""} airport`;
  const place = active.length ? `${base} with ${active.map((a) => PHRASE[a]).join(", ")}` : base;

  return (
    <div data-testid="airport-hotels">
      <div className="font-heading font-900 text-xl mb-1 flex items-center gap-2">
        <Hotel className="w-5 h-5 text-teal-700" /> Hotels near {iata || airportName}
      </div>
      <p className="text-xs text-muted-foreground mb-3">Pick what matters for your layover or early flight, then compare on your favorite booking site.</p>
      <div className="flex flex-wrap gap-1.5 mb-3">
        {FILTERS.map(([id, label]) => (
          <button key={id} onClick={() => toggle(id)} data-testid={`airport-hotel-filter-${id}`}
            className={`px-2.5 py-1 text-xs font-700 border ${active.includes(id) ? "bg-teal-700 text-white border-teal-700" : "bg-white border-zinc-300 text-zinc-600 hover:border-zinc-500"}`}>
            {label}
          </button>
        ))}
      </div>
      <HotelProviderSearch key={place} initial={{ place }} campaign="TP-AIRPORT-HOTELS"
        placement="airport-page" heading="Compare stays for your dates" />
    </div>
  );
}
